import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Course } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface AddCourseState {
  title: string;
  description: string;
  image: string;
  ressource: string;
  ressourceType: string;
  courses: Course[];
}

// Define the initial state using that type
const initialState: AddCourseState = {
  ressourceType: "",
  description: "",
  image: "",
  title: "",
  ressource: "",
  courses: [],
};

export const addCourseSlice = createSlice({
  name: "addCourse",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    setDescription: (state, action: PayloadAction<string>) => {
      state.description = action.payload;
    },
    setCourses: (state, action: PayloadAction<Course[]>) => {
      state.courses = action.payload;
    },
    setImage: (state, action: PayloadAction<any>) => {
      state.image = action.payload;
    },
    setRessource: (state, action: PayloadAction<string>) => {
      state.ressource = action.payload;
    },
    setRessourceType: (state, action: PayloadAction<string>) => {
      state.ressourceType = action.payload;
    },
  },
});

export const {
  setTitle,
  setDescription,
  setCourses,
  setImage,
  setRessource,
  setRessourceType,
} = addCourseSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getAddCourseData = (state: RootState) => state.addCourse;
export default addCourseSlice.reducer;
